module.exports = __webpack_public_path__ + "img/17.414e67de.png";